import React from 'react';

const IframeNotice = () => (
  <div style={{ background: 'black', color: 'white', height: '100vh', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', padding: '20px', textAlign: 'center' }}>
    <h1 style={{ fontSize: '24px', marginBottom: '20px', color: '#FF69B4' }}>PROBLEMA IFRAME RILEVATO</h1>
    <p style={{ fontSize: '16px', marginBottom: '20px' }}>Stripe non funziona negli iframe. Devi aprire l'app in una nuova scheda.</p>
    <div style={{ background: '#1a1a1a', padding: '15px', borderRadius: '8px', marginBottom: '20px', border: '1px solid #333' }}>
      <p style={{ fontSize: '14px', marginBottom: '10px', color: '#ccc' }}>COPIA QUESTO URL E APRILO IN UNA NUOVA SCHEDA:</p>
      <div style={{ background: '#333', padding: '10px', borderRadius: '4px', fontFamily: 'monospace', fontSize: '14px', color: '#FF69B4', wordBreak: 'break-all', userSelect: 'all' }}>
        {window.location.href}
      </div>
    </div>
  </div>
);

export default IframeNotice;
